import { useState, createContext, useContext } from "react";
import { translations } from "@/translations";

// Language Context
const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within LanguageProvider");
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem("petalfinder-language");
    return saved || "es";
  });

  const t = translations[language] || translations.es;

  const changeLanguage = (lang) => {
    setLanguage(lang);
    localStorage.setItem("petalfinder-language", lang);
  };

  return (
    <LanguageContext.Provider value={{ language, t, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};
